import { inView as inView12, animate as animate16, stagger as stagger6 } from "vendor";
import { EffectCarousel, getHeadingKeyframe, imageLoaded } from "theme";

var TabSlider = class extends HTMLElement {
  constructor() {
    super();
    this._imageCarousel = this.querySelector("tab-slider-image-list");
    this._contentCarousel = this.querySelector("tab-slider-content-list");
    this.addEventListener("control:prev", () => {
      this._imageCarousel.previous();
      this._contentCarousel.previous();
    });
    this.addEventListener("control:next", () => {
      this._imageCarousel.next();
      this._contentCarousel.next();
    });
    this.addEventListener("control:select", (e) => {
      this._imageCarousel.select(e.detail.index);
      this._contentCarousel.select(e.detail.index);
    });
    this._contentCarousel.querySelectorAll('.prose').forEach((el) => {
      el.addEventListener("animationend", () => {
        this._imageCarousel.next();
        this._contentCarousel.next();
      });
    });
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => {
        if (event.target.hasAttribute("image-id")) {
          const index = this._imageCarousel.items.findIndex(
            (item) => item.id === event.target.getAttribute("image-id")
          );
          this._imageCarousel.select(index);
        }
      });
    }
  }
};

var TabSliderImageList = class extends EffectCarousel {
  constructor() {
    super();
    this._currentIndex = 0;
    inView12(this, this._reveal.bind(this));
  }
  
  async _reveal() {
    await imageLoaded(this.querySelectorAll("img"));
    // Hide all images
    this.querySelectorAll("img").forEach((el) => {
      el.style.display = "none";
      el.style.opacity = 0;
    });
    // Show the first image
    if (this.items && this.items[0]) {
      this.items[0].style.display = "block";
      this.items[0].style.opacity = 1;
    }
  }
  
  select(index) {
    if (index === this._currentIndex) return Promise.resolve();
    const fromSlide = this.items[this._currentIndex];
    const toSlide = this.items[index];
    this._currentIndex = index;
    return this._transitionTo(fromSlide, toSlide, {});
  }
  
  next() {
    let nextIndex = this._currentIndex + 1;
    if (nextIndex >= this.items.length) nextIndex = 0;
    return this.select(nextIndex);
  }
  
  previous() {
    let prevIndex = this._currentIndex - 1;
    if (prevIndex < 0) prevIndex = this.items.length - 1;
    return this.select(prevIndex);
  }
  
  _transitionTo(fromSlide, toSlide, { direction, animate: animate19 = true } = {}) {
    const transitionSpeed = 300;
    return new Promise((resolve) => {
      function fadeInToSlide() {
        toSlide.style.display = "block";
        toSlide.style.transition = `opacity ${transitionSpeed}ms ease-in-out`;
        void toSlide.offsetWidth;
        toSlide.style.opacity = 1;
        toSlide.addEventListener("transitionend", function handler() {
          toSlide.removeEventListener("transitionend", handler);
          resolve();
        });
      }
      if (fromSlide && fromSlide.style.display !== "none") {
        fromSlide.style.transition = `opacity ${transitionSpeed}ms ease-in-out`;
        fromSlide.style.opacity = 0;
        fromSlide.addEventListener("transitionend", function handler() {
          fromSlide.style.display = "none";
          fromSlide.removeEventListener("transitionend", handler);
          fadeInToSlide();
        });
      } else {
        fadeInToSlide();
      }
    });
  }
};

var TabSliderContentList = class extends EffectCarousel {
  constructor() {
    super();
    inView12(this, this._reveal.bind(this));
    this.mediaQuery = "(max-width: 699px)";
    this.querySelectorAll(".prose").forEach((el, index) => {
      el.addEventListener("click", () => {
        this.dispatchEvent(
          new CustomEvent("control:select", {
            bubbles: true,
            cancelable: true,
            detail: { index: index },
          })
        );
      });
    });
    this.intersectingEntry = null;
    this.items.forEach((item) => {
      const intersectionCallback = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.intersectingEntry = entry.target;
          }
        });
      };
      const options = {
        root: this,
        rootMargin: "0px",
        threshold: 1.0,
      };
      const observer = new IntersectionObserver(intersectionCallback, options);
      observer.observe(item);
    });
    this.addEventListener("scrollend", () => {
      if (window.matchMedia(this.mediaQuery).matches && this.intersectingEntry) {
        const index = this.items.indexOf(this.intersectingEntry);
        this.dispatchEvent(
          new CustomEvent("control:select", {
            bubbles: true,
            cancelable: true,
            detail: { index: index },
          })
        );
      }
    });
  }
  
  isVisible(ele, container) {
    const eleTop = ele.offsetTop;
    const eleBottom = eleTop + ele.clientHeight;
    const containerTop = container.scrollTop;
    const containerBottom = containerTop + container.clientHeight;
    return (
      (eleTop >= containerTop && eleBottom <= containerBottom) ||
      (eleTop < containerTop && containerTop < eleBottom) ||
      (eleTop < containerBottom && containerBottom < eleBottom)
    );
  }
  
  _reveal() {
    animate16(...getHeadingKeyframe(this.querySelector('[reveal-on-scroll="true"]')));
  }
  
  _transitionTo(fromSlide, toSlide, { direction = "next", animate: animate19 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    if (window.matchMedia(this.mediaQuery).matches) {
      toSlide.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
    }
    return new Promise((resolve) => {
      const fadeSpeed = animate19 ? parseFloat(this.getAttribute("fade-speed") || 0.5) * 1000 : 0;
      toSlide.style.transition = `opacity ${fadeSpeed}ms ease-in-out`;
      toSlide.style.opacity = 1;
      setTimeout(resolve, fadeSpeed);
    });
  }
};

if (!window.customElements.get("tab-slider")) {
  window.customElements.define("tab-slider", TabSlider);
}
if (!window.customElements.get("tab-slider-image-list")) {
  window.customElements.define("tab-slider-image-list", TabSliderImageList);
}
if (!window.customElements.get("tab-slider-content-list")) {
  window.customElements.define("tab-slider-content-list", TabSliderContentList);
}
